query getPinnedEntities(
  $teamIds: [String!]!
  $personIds: [String!]!
  $tagIds: [ID!]!
) {
  teams: getGroups(groupIds: $teamIds) {
    id
    name
    type
    attributes {
      id
      attributeType
      subtype
      value
      label
    }
  }
  people: getPeopleByIds(ids: $personIds) {
    aggregateId
    firstName
    surname
    avatar
    jobTitle
  }
  tags: getTagsByIds(tagIds: $tagIds) {
    id
    displayValue
    tagTypeName
    attributes
  }
}
